// Module
var code = "<div class=\"footer-modify-position-screen\">\r\n    <terceraButton name=\"modifyBtn\" text=\"{{.modifyBtnText}}\" terceraButtonStyle=\"js-button-ok\" on-btnClick=\"@this.modify()\" />\r\n    <terceraButton name=\"cancelBtn\" text=\"{{.cancelBtnText}}\" terceraButtonStyle=\"js-button-gray25\" on-btnClick=\"@this.closeScreen()\" />\r\n</div>";
// Exports
export default code;